import React, { Component } from "react";
import PropTypes from "prop-types";
import getContent from "pp-react-l10n";
import getHTMLElement from "../lib/setHtmlHelper";
import formatDate from "../lib/dateHelper";

class Relatedstories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showItems: 4,
    };
  }

  render() {
    const getRealtedHeading = getContent("staticContent");
    const urlSlug = this.props.articleInfo.content["url-slug"];
    const relatedStoriesInfo =
      this.props.articleInfo.content["related-articles"];
    const topicsHash = this.props.topicsHash;
    const newRelatedStoriesInfo = relatedStoriesInfo.filter(
      (value) => value.content["url-slug"] !== urlSlug
    );
    const country = this.props.country.toLowerCase();
    const fontChange =
      country === "vn" && this.props.locale === "vi_VN" ? "vnFont" : country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";
    const { timezone, language } = this.props;
    if (newRelatedStoriesInfo.length > 0) {
      return (
        <div className="relatedStories" id="related-stories">
          <div className="relate-stories-component">
            <h2 className={`vx_text-2 mainheading ${fontChange}`}>
              {getRealtedHeading("brc.realtedStories")}
            </h2>
            <ul className="relatedstories-container">
              {newRelatedStoriesInfo
                .slice(0, this.state.showItems)
                .map((story, index) => {
                  const updatedDate = formatDate({
                    dateToFormat: story.metadata.updated_time,
                    country,
                    timezone,
                    language,
                  });

                  return (
                    <li className="relatedstories-item" key={index}>
                      <hr className="story-divider" />
                      <div>
                        <a
                          data-pa-click={`brcRelatedStoriesClick|${story.content["url-slug"]}`}
                          tabIndex="-1"
                          className="rs-arrow"
                          aria-label="button as arrow"
                          href={story.content["url-slug"]}
                        />
                      </div>

                      {!story.content["sm-bg"] ? (
                        <div className="rstory">
                          <div className="vx_text-5 relatedstories_category">
                            {(topicsHash[
                              story.metadata.category &&
                              story.metadata.category[1]
                            ] ||
                              (story.metadata.category &&
                                story.metadata.category[1])) &&
                              (
                                topicsHash[
                                story.metadata.category &&
                                story.metadata.category[1]
                                ] ||
                                (story.metadata.category &&
                                  story.metadata.category[1])
                              ).toUpperCase()}
                          </div>

                          <h3 key={story.content.heading + index}>
                            <a
                              data-pa-click={`brcRelatedStoriesClick|${story.content["url-slug"]}`}
                              className={`relatedstories_title ${fontChange}`}
                              href={story.content["url-slug"]}
                              key={story.content["url-slug"] + index}
                            >
                              {getHTMLElement(story.content.heading, {
                                useHTML: true,
                              })}
                            </a>
                          </h3>

                          <div
                            className="vx_text-body_secondary relatedstories_date"
                            key={updatedDate + index}
                          >
                            {updatedDate === "Invalid date" ? "" : updatedDate}
                          </div>

                          <div
                            className="vx_text-body relatedstories_description ellipsis"
                            key={story.content.desc + index}
                          >
                            <span className="text-concat">
                              {story.content.desc.replace(/(<([^>]+)>)/gi, "")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="rstory">
                          <div
                            className="set-image"
                            style={{
                              backgroundImage:
                                `url(${story.content["sm-bg"]})`,
                            }}
                          />
                          <div className="vx_text-5 relatedstories_category">
                            {topicsHash[
                              story.metadata.category &&
                              story.metadata.category[1]
                            ] &&
                              topicsHash[
                                story.metadata.category &&
                                story.metadata.category[1]
                              ].toUpperCase()}
                          </div>

                          <h3 key={story.content.heading + index}>
                            <a
                              data-pa-click={`brcRelatedStoriesClick|${story.content["url-slug"]}`}
                              className={`story-ref image_title ${fontChange}`}
                              href={story.content["url-slug"]}
                              key={story.content["url-slug"] + index}
                            >
                              {getHTMLElement(story.content.heading, {
                                useHTML: true,
                              })}
                            </a>
                          </h3>

                          <div
                            className="vx_text-body_secondary relatedstories_date"
                            key={updatedDate + index}
                          >
                            {updatedDate === "Invalid date" ? "" : updatedDate}
                          </div>

                          <div
                            className="vx_text-body image_des ellipsis"
                            key={story.content.desc + index}
                          >
                            <span className="text-concat">
                              {story.content.desc.replace(/(<([^>]+)>)/gi, "")}
                            </span>
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      );
    }
    return <span />;
  }
}

export default Relatedstories;

Relatedstories.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      ["related-articles"]: PropTypes.array,
      ["url-slug"]: PropTypes.string,
    }),
  }),
  topicsHash: PropTypes.object,
};
